import React, { useState } from "react";
import PropTypes from "prop-types";

export const GlobalFilter = ({ filter, setFilter, titleText, placeholder }) => {
  const [value, setValue] = useState(filter);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setFilter(value || undefined);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (newValue === "") {
      setFilter(undefined);
    }
  };

  return (
    <span>
      {titleText}
      <input
        value={value || ""}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
    </span>
  );
};

GlobalFilter.propTypes = {
  filter: PropTypes.any,
  setFilter: PropTypes.func.isRequired,
  titleText: PropTypes.string,
  placeholder: PropTypes.string
};
